import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-source-beneficiary.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetSourceBeneficiaryDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metSourceBeneficiaryEntity = useAppSelector(state => state.metSourceBeneficiary.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metSourceBeneficiaryDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.detail.title">MetSourceBeneficiary</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metSourceBeneficiaryEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.code">Code</Translate>
            </span>
          </dt>
          <dd>{metSourceBeneficiaryEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.name">Name</Translate>
            </span>
          </dt>
          <dd>{metSourceBeneficiaryEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{metSourceBeneficiaryEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{metSourceBeneficiaryEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.status">Status</Translate>
            </span>
          </dt>
          <dd>{metSourceBeneficiaryEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/met-source-beneficiary" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-source-beneficiary/${metSourceBeneficiaryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetSourceBeneficiaryDetail;
